/* unplugin-vue-components disabled */import script from "./SingleChoice.vue?vue&type=script&setup=true&lang=js"
export * from "./SingleChoice.vue?vue&type=script&setup=true&lang=js"

import "./SingleChoice.vue?vue&type=style&index=0&id=1a10000b&lang=scss"

const __exports__ = script;

export default __exports__